import { PageId } from 'constants/pages'
import { TPageMapValue } from 'models/common.model'
import { lazy } from 'react'
import { PageIdWoofzPpday75 } from './pages'

type TIdToPageMapWoofzPpday75 = Record<PageIdWoofzPpday75, TPageMapValue>

export const ID_TO_PAGE_MAP_WOOFZ_PPDAY_75: TIdToPageMapWoofzPpday75 = {
  [PageId.SUBSCRIPTIONS_PPDAY_75_N]: {
    Component: lazy(() =>
      import(
        'nove8/cohorts/woofz_ppday/woofz_ppday_75/pages/subscriptions/SubscriptionPpday75'
      ).then((m) => ({
        default: m.SubscriptionsPpday75,
      })),
    ),
    preload: () =>
      import(
        'nove8/cohorts/woofz_ppday/woofz_ppday_75/pages/subscriptions/SubscriptionPpday75'
      ),
  },
  [PageId.CHAT_UPSELL_PPDAY_75]: {
    Component: lazy(() =>
      import(
        'nove8/cohorts/woofz_ppday/woofz_ppday_75/pages/upsell/ChatUpsellNewFlow'
      ).then((m) => ({
        default: m.ChatUpsellNewFlow,
      })),
    ),
    preload: () =>
      import(
        'nove8/cohorts/woofz_ppday/woofz_ppday_75/pages/upsell/ChatUpsellNewFlow'
      ),
  },
  [PageId.UPSELL_PPDAY_75]: {
    Component: lazy(() =>
      import(
        'nove8/cohorts/woofz_ppday/woofz_ppday_75/pages/upsell/Upsell'
      ).then((m) => ({
        default: m.Upsell,
      })),
    ),
    preload: () =>
      import('nove8/cohorts/woofz_ppday/woofz_ppday_75/pages/upsell/Upsell'),
  },
  [PageIdWoofzPpday75.DOWNLOAD_PPDAY_75]: {
    Component: lazy(() =>
      import(
        'nove8/cohorts/woofz_ppday/woofz_ppday_75/pages/download-app/DownloadApp'
      ).then((m) => ({
        default: m.DownloadApp,
      })),
    ),
    preload: () =>
      import(
        'nove8/cohorts/woofz_ppday/woofz_ppday_75/pages/download-app/DownloadApp'
      ),
  },
  [PageIdWoofzPpday75.ACCOUNT_NOVE8]: {
    Component: lazy(() =>
      import('nove8/modules/account/AccountNove8').then((m) => ({
        default: m.AccountNove8,
      })),
    ),
    preload: () => import('nove8/modules/account/AccountNove8'),
  },
}
